import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UserSessionService } from 'bna-angular-auth-client';
import { ClientSettingsService } from 'src/app/core/services/auth/client-settings.service';
import { AppSettings } from 'src/app/shared/constants/app-settings.constants';

@Component({
  selector: 'app-account-in-review',
  templateUrl: './account-in-review.component.html',
  styleUrls: ['./account-in-review.component.scss'],
})
export class AccountInReviewComponent implements OnInit {
  constructor(private userSessionService: UserSessionService) {}

  ngOnInit() {
    document.body.classList.add('account-review');
  }

  ngOnDestroy() {
    document.body.classList.remove('account-review');
  }

  backToSignIn() {
    this.userSessionService.signOut();
  }
}
